

'use strict';

import { recaptchaTokenRefresh } from './recaptcha';




const postUrl = '/ajax/customer/requestPasswordReset';
const forgotPassModal =  document.querySelector('.forgot-password-modal');
const forgotPassForm = document.querySelector('.forgot-password');
const modalMessage = document.querySelector('.modal-body-message');



async function handleResponse ( response ) {
    const jsonResponse = await response.json();
    const responseData = jsonResponse.data;

    if ( response.status !== 200 ) {
        throw responseData;
    }

    return responseData;
}


function resetPasswordForm () {
    modalMessage.innerHTML = '';
    forgotPassForm.style.display = '';

    forgotPassForm.querySelector('[name="email"]').value = '';
}



if ( forgotPassModal && forgotPassForm && modalMessage ) {
    forgotPassForm.addEventListener('submit', evt => {
        evt.preventDefault();

        const formData = new FormData(forgotPassForm);

        window.fetch(postUrl, {
            method: 'POST',
            body: formData,
        })
            .then(handleResponse)
            .then(response => {
                // Hide form on success
                forgotPassForm.style.display = 'none';
                modalMessage.classList.remove('error');

                return response;
            })
            .catch(response => {
                modalMessage.classList.add('error');

                return response;
            })
            .then(response => {
                // Always display message
                modalMessage.innerHTML = response.message;

                recaptchaTokenRefresh();
            });
    });



    // Reset form when closed
    const observer = new MutationObserver(() => {
        if (
            forgotPassModal.attributes['aria-hidden']
            && forgotPassModal.attributes['aria-hidden'].value === 'true'
        ) {
            resetPasswordForm();
        }
    })

    observer.observe(forgotPassModal, {
        attributes: true, 
        attributeFilter: ['class'],
    });
}
